import React from "react";
import classNames from "classnames";

import styles from "./Layout.css";

export default function Sidebar({ children, className }) {
  return (
    <div role="complementary" className={classNames(styles.sidebar, className)}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Library/Layout/Sidebar.js